export class FormulaCostItem {

    public id: string;
    public formulaCostId: string;
    public jsonDeterminants: string;
    public jsonLogicFormula: any;
    public infixFormula: string;
    public meta: any;
    public sortOrder: number;

    public prettyPrintInfixFormula: string;
}
